itsoftApp.createModule("select", function () {
    var module = this;

    var libraries = {
        select: {
            name: "choice",
            queue: [],
            started: false,
            loaded: false,
            style: "assets/scripts/choices/choices.min.css",
            script: "assets/scripts/choices/choices.min.js"
        }
    }

    module.selects = {
        connectSelects: []
    }

    var setSelect = function (element) {
        var initSelect = function () {
            var form = element.closest("form");
            var selectItem = element.querySelector(".js-select-item");
            var selectContainer = element.querySelector(".js-select-container");
            var selectWrapper = selectItem.closest(".js-select");
            var activeOptionValue;

            var fragment = document.createDocumentFragment();

            var getSelectName = function (select, string) {
                var selectClass = string;
                return selectClass += " choices--" + select.getAttribute("id"); 
            }

            var createOptionEl = function (item) {
                var optionEl = document.createElement("option");
                var wordsArray = item.city.split("");
                var newWords = "";

                Array.prototype.forEach.call(wordsArray, function (word) {
                    newWords += itsoftApp.utils.translit(word);
                });

                newWords.replace(/\s/g, '+');

                optionEl.textContent = item.city;
                optionEl.value = newWords;

                fragment.appendChild(optionEl);
            }

            var IsJsonString = function (str) {
                try {
                    JSON.parse(str);
                } catch (e) {
                    return false;
                }

                return true;
            }

            var setNewOptions = function (response) {
                var parseResponse;

                if (IsJsonString(response)) {
                    parseResponse = JSON.parse(response);
                } else {
                    parseResponse = response;
                }

                Array.prototype.forEach.call(parseResponse, function (item) {
                    createOptionEl(item);
                });

                selectItem.appendChild(fragment);

                createSelect();
            }

            var createSelect = function () {
                var customSelect = new Choices(selectItem, {
                    position: "bottom",
                    searchEnabled: (function () {
                        if (selectItem.hasAttribute("data-search")) {
                            return true;
                        } else {
                            return false;
                        }
                    })(),
                    loadingText: "",
                    noResultsText: "",
                    noChoicesText: "",
                    itemSelectText: "",
                    shouldSort: false,
                    classNames: {
                        containerOuter: getSelectName(selectItem, "choices"),
                        placeholder: "form__select-placeholder"
                    },
                    removeItems: false,
                    searchFields: ['label'],
                    searchResultLimit: 10000,
                    fuseOptions: {
                        findAllMatches: true,
                        threshold: 0.0
                    },
                    callbackOnInit: function () {
                        selectContainer.classList.add("js-inited");
                    }
                });

                var placeholder = selectWrapper.querySelector(".choices__list--dropdown .form__select-placeholder");
                var placeholderText = placeholder.textContent;
                var dropdown = selectWrapper.querySelector(".choices__list--dropdown");
                dropdown.setAttribute("data-placeholder", placeholderText);

                if (selectItem.hasAttribute("data-search")) {
                    customSelect.passedElement.element.addEventListener(
                        "choice",
                        function (event) {
                            setTimeout(function () {
                                selectWrapper.classList.add("is-selected");

                                if (selectWrapper.classList.contains("js-error")) {
                                    selectWrapper.classList.remove("js-error");
                                    selectWrapper.closest(".js-error-wrapper").classList.remove("js-error-wrapper");
                                }
                            });
                        },
                        false
                    );

                    var searchValue = "";

                    customSelect.passedElement.element.addEventListener(
                        "search",
                        function (event) {
                            searchValue = event.detail.value;
                        },
                        false
                    );

                    customSelect.passedElement.element.addEventListener(
                        "showDropdown",
                        function (event) {
                            var input = selectWrapper.querySelector(".choices__list--dropdown .choices__input");

                            if (input) {
                                input.value = searchValue;
                            }
                        },
                        false
                    );
                }

                module.selects.connectSelects.push(customSelect);
            }

            if (selectItem.hasAttribute("data-ajax")) {
                var data = itsoftApp.utils.loadBlock(selectItem.getAttribute("data-ajax"), setNewOptions);
            } else {
                createSelect();
            }
        }

        itsoftApp.modules.startLoad.callback(initSelect, libraries.select);
    }

    this.callback = setSelect;
});